import { Container } from 'pixi.js';

export function areBoxesCollide(a: Container, b: Container) {
    const box1 = a.getBounds();
    const box2 = b.getBounds();

    return box1.minX <= box2.maxX && box1.maxX >= box2.minX && box1.minY <= box2.maxY && box1.maxY >= box2.minY;
}

export interface CollisionResult {
    collision: boolean;
    intersectionArea: number;
}

export function detectCollisionWithArea(a: Container, b: Container): CollisionResult {
    const box1 = a.getBounds();
    const box2 = b.getBounds();

    const hasCollision = box1.minX <= box2.maxX && box1.maxX >= box2.minX && 
                        box1.minY <= box2.maxY && box1.maxY >= box2.minY;

    if (!hasCollision) {
        return {
            collision: false,
            intersectionArea: 0
        };
    }

    const intersectionMinX = Math.max(box1.minX, box2.minX);
    const intersectionMaxX = Math.min(box1.maxX, box2.maxX);
    const intersectionMinY = Math.max(box1.minY, box2.minY);
    const intersectionMaxY = Math.min(box1.maxY, box2.maxY);

    const intersectionWidth = intersectionMaxX - intersectionMinX;
    const intersectionHeight = intersectionMaxY - intersectionMinY;
    const intersectionArea = intersectionWidth * intersectionHeight;

    return {
        collision: true,
        intersectionArea: intersectionArea
    };
}
